<template>
  <v-text-field
    type="date"
    :label="labelText"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: "BaseDatePicker",
  props: {
    "label-text": { type: String, default: () => "" }
  }
};
</script>
